<div class="header-text">Incident & Injury Classification</div>
<div class="row g-3 mt-1">
    <div class="col-md-4">
        <label class="form-label">Human Resources Contacted <span class="text-danger">*</span></label>
        <dx-select-box [(value)]="incidentReport.humanResourcesContacted" [items]="yesOrNoOptions" valueExpr="value"
            displayExpr="text" stylingMode="filled" placeholder="Select..." [readOnly]="isReadOnly">
            <dx-validator>
                <dxi-validation-rule type="custom" [validationCallback]="validateYesNo"
                    message="Human Resources Contacted is required"></dxi-validation-rule>
            </dx-validator>
        </dx-select-box>
    </div>
    <div class="col-md-4">
        <label class="form-label">Incident Category <span class="text-danger">*</span></label>
        <dx-select-box [(value)]="incidentReport.category" [items]="incidentCategoryOptions" valueExpr="value"
            displayExpr="text" stylingMode="filled" placeholder="Select Incident Category" [readOnly]="isReadOnly">
            <dx-validator>
                <dxi-validation-rule type="required" message="Incident Category is required"></dxi-validation-rule>
            </dx-validator>
        </dx-select-box>
    </div>
    <div class="col-md-4">
        <label class="form-label">Type of Incident <span class="text-danger">*</span></label>
        <dx-select-box [(value)]="incidentReport.type" [items]="incidentTypeOptions" valueExpr="value"
            displayExpr="text" stylingMode="filled" placeholder="Select Type of Incident" [readOnly]="isReadOnly">
            <dx-validator>
                <dxi-validation-rule type="required" message="Type of Incident is required"></dxi-validation-rule>
            </dx-validator>
        </dx-select-box>
    </div>
</div>
<div class="row g-3 mt-1">
    <div class="col-md-4">
        <label class="form-label">Incident Location <span class="text-danger">*</span></label>
        <dx-select-box [(value)]="incidentReport.location" [items]="incidentLocationOptions" valueExpr="value"
            displayExpr="text" stylingMode="filled" placeholder="Select Incident Location" [readOnly]="isReadOnly">
            <dx-validator>
                <dxi-validation-rule type="required" message="Incident Location is required"></dxi-validation-rule>
            </dx-validator>
        </dx-select-box>
    </div>
    <div class="col-md-4">
        <label class="form-label">Type of Injury <span class="text-danger">*</span></label>
        <dx-select-box [(value)]="incidentReport.injuryType" [items]="injuryTypeOptions" valueExpr="value"
            displayExpr="text" stylingMode="filled" [readOnly]="isReadOnly" placeholder="Select Type of Injury">
            <dx-validator>
                <dxi-validation-rule type="required" message="Type of Injury is required"></dxi-validation-rule>
            </dx-validator>
        </dx-select-box>
    </div>
    <div class="col-md-4">
        <label class="form-label">Outside Medical? <span class="text-danger">*</span></label>
        <dx-select-box [(value)]="incidentReport.outsideMedical" [items]="yesOrNoOptions" valueExpr="value"
            displayExpr="text" stylingMode="filled" [readOnly]="isReadOnly" placeholder="Select...">
            <dx-validator>
                <dxi-validation-rule type="custom" [validationCallback]="validateYesNo"
                    message="Outside Medical is required"></dxi-validation-rule>
            </dx-validator>
        </dx-select-box>
    </div>
</div>